<template>
  <div>
    <b-modal ref="sellerSelectModel" size="lg" title="履歴" hide-footer=true>
      <b-row>
        <b-col sm="11" class="text-left">
          <h5>{{ dispProductInfo }}</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <h6>{{ dispProductCount }}</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="items" :fields="fields"
                  :current-page="currentPage" :per-page="perPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  :filter="filter" @filtered="onFiltered">
          <!-- <template slot="inboundDate" slot-scope="row"><label>{{formatDate(row.value)}}</label></template> -->
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <h6>{{ dispShippingProductCount }}</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="shippingItems" :fields="fields2"
                  :current-page="currentPage" :per-page="perPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  :filter="filter" @filtered="onFiltered">
          <!-- <template slot="shippingDate" slot-scope="row"><label>{{formatDate(row.value)}}</label></template> -->
          <!-- <template slot="createDate" slot-scope="row"><label>{{formatDate(row.value)}}</label></template> -->
          </b-table>
          <!-- <b-col md="6">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col> -->
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import * as utility from '@/utility';
import * as api from '@/api';

export default {
  props: {
    // item: {
    //   default: [],
    // }
  },
  computed: {
    dispProductCount() {
      return '入庫件数: ' + this.totalRows + '件　　';
    },
    dispShippingProductCount() {
      return '発送件数: ' + this.totalShippingRows + '件　　';
    },
    dispProductInfo() {
      return '[ ASIN ] ' + this.item.asin + '　 [商品名] ' + this.item.productNameEn;
    },
  },
  data() {
    return {
      items: [],
      shippingItems: [],
      item: [],
      fields: [
        { key: 'inboundDate',     label: '入庫日時', sortable: true, variant: 'base' },
        { key: 'inboundQuantity', label: '入庫数', sortable: true, variant: 'base' },
        // { key: 'shippingQuantity',label: '発送済み数量', sortable: true, variant: 'base' },
        { key: 'createUser',            label: '入庫者', sortable: true, variant: 'base' },
        // { key: 'createDate',            label: '入庫時刻', sortable: true, variant: 'base' },
      ],
      fields2: [
        { key: 'shippingDate',     label: '発送日時', sortable: true, variant: 'base' },
        { key: 'shippingQuantity', label: '発送数', sortable: true, variant: 'base' },
        // { key: 'shippingQuantity',label: '発送済み数量', sortable: true, variant: 'base' },
        { key: 'createUser',            label: '発送者', sortable: true, variant: 'base' },
        // { key: 'createDate',            label: '発送時刻', sortable: true, variant: 'base' },
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      totalShippingRows: 0,
      pageOptions: [ 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activate: false,
      modalInfo: { title: '', content: '' },
      sizeTypeFilter: null,
      productStatusFilter: '1',
      sizeType: [
        { value: null, text: '全サイズ' },
        { value: '1', text: 'light' },
        { value: '2', text: 'standard' },
        { value: '3', text: 'large' },
      ],
      productStatus: [
        { value: null, text: '全部' },
        { value: '1', text: '未発送' },
        { value: '2', text: '発送済' },
      ],
      member_id: '',
      member_name: '',
      jan_code: '',
      name_filter: '',
      size_filter: '1',
      status_filter: '1',
      not_inbound_flag: true,
      editRowKey: null,
      selectedRowItem: {},
      modalInfo: { title: '', content: '' },
      confirmMessage: ''
    };
  },
  methods: {
    formatDate(value) {
      return utility.formatDate(value);
    },
    showModal(item) {
      this.item = item;
      if(item.orderId == null || item.orderId === ''){
        item.orderId = '0';
      }
      api.getInboundHiistory(item.orderId, (data) =>{
        this.items = data.items;
        this.shippingItems = data.shippingItems;
        this.totalRows = this.items.length;
        this.totalShippingRows = this.shippingItems.length;
        this.$refs.sellerSelectModel.show();
      });
    },
    hideModal() {
      this.$refs.sellerSelectModel.hide();
    }
  },
};
</script>

<style>
.margin-left {
  margin-left: 1rem;
}
.margin-top {
  margin-top: 1rem;
}
.image-sm {
  align-content: left;
  height: 1.5rem;
  width: 1.5rem; 
}
</style>

